module.exports = new __parcel__URL__("shop_machines_barracks.ebd23424.png").toString();